import { render } from "./ArrowChart.vue?vue&type=template&id=0c4b8aac&scoped=true"
import script from "./ArrowChart.vue?vue&type=script&lang=js"
export * from "./ArrowChart.vue?vue&type=script&lang=js"

import "./ArrowChart.vue?vue&type=style&index=0&id=0c4b8aac&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4b8aac"]])

export default __exports__